var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.urlValidator(_vm.image) || _vm.haveBase64(_vm.image))?_c('img',{style:(_vm.styles),attrs:{"src":_vm.image}}):_c('img',{style:(_vm.styles),attrs:{"src":`data:image/png;base64,${_vm.image}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }